import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/serviceSalesSaga";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import SecondaryCategory from "./smartComponents/secondaryCategory";
import CustomDateRanges from "./smartComponents/customDateRanges";
import PrimaryCategory from "./smartComponents/primaryCategory";
import IncludeReturns from "./smartComponents/includeReturns";
import GroupCategory from "./smartComponents/groupCategory";
import DatePicker from "./smartComponents/datePicker";
import PeriodType from "./smartComponents/periodType";
import "./serviceSalesModule.css";

const ServiceSalesModule = (props) => {
  const dispatch = useDispatch();
  const useSecondaryCategories = useSelector(
    (state) => state.commonReducer.commonProps.useSecondaryCategories
  );
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    filtersDirty,
    startDate,
    endDate,
    primaryCategoriesLoading,
    secondaryCategoriesLoading
  } = useSelector((state) => state.serviceSales);
  const includeReturnsLabel = useSelector(
    (state) => state.serviceSales.filters.toggles.includeReturns.label
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const renderUpdateBtn = () => {
    if (filtersDirty & !isLoading & (startDate !== "Invalid date") & (endDate !== "Invalid date")) {
      return (
        <button
          className="submit override-submit"
          onClick={() => dispatch(actionCreators.updateData())}
        >
          Update
        </button>
      );
    }

    return null;
  };

  const renderResetBtn = () => {
    if (filtersDirty & !isLoading) {
      return (
        <button
          className="submit reset override-submit"
          onClick={() => dispatch(actionCreators.resetFilters())}
        >
          Reset
        </button>
      );
    }

    return null;
  };

  return (
    <div id="service-sales-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Service Sales"
        customClass="service-sales-section"
        isLoading={isLoading}
        content={
          <div>
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filter">
                <div>
                  {useSecondaryCategories && (
                    <div className="select-box-no-width">
                      <p>Primary Category</p>
                      {!primaryCategoriesLoading ? (
                        <PrimaryCategory />
                      ) : (
                        <LoadingAnimation uiLoader />
                      )}
                    </div>
                  )}
                  <div className="select-box-no-width">
                    <p>{`${useSecondaryCategories ? "Secondary" : ""} Category`}</p>
                    {!secondaryCategoriesLoading ? (
                      <SecondaryCategory />
                    ) : (
                      <LoadingAnimation uiLoader />
                    )}
                  </div>
                  {useSecondaryCategories && (
                    <div className="select-box-no-width">
                      <p>Group By Secondary</p>
                      <GroupCategory />
                    </div>
                  )}
                </div>
                <div className="top-right-filter">
                  <div className="select-box-no-width">
                    <p>Period Type</p>
                    <PeriodType />
                  </div>
                  <div className="select-box-no-width date-range-select-box">
                    <p>Date Range</p>
                    <CustomDateRanges />
                  </div>

                  <div className="date-select-box select-box-no-width multi">
                    <>
                      <p>Date</p>
                      <DatePicker />
                    </>
                  </div>

                  {renderUpdateBtn()}
                  {renderResetBtn()}
                </div>
              </div>

              <div className="bottom-filter">
                <div>
                  {includeReturnsLabel && (
                    <div className="select-box-no-width">
                      <p>{includeReturnsLabel}</p>
                      <IncludeReturns label={includeReturnsLabel} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="chart-root">
              {updatesLoading ? (
                <LoadingAnimation text="Updating data..." />
              ) : (
                <TableOrStackedBarChart />
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default memo(ServiceSalesModule);
